<template>
  <div class="sectionFrame">
    <section class="statisticsSection">
      <InfographicSection
        :button-class-name="'btn-round-black'"
        :has-main-heading-title="true"
        :has-white-text="false"
        :on-button-click="() => onRedirect('PodcasterRegister')"
        :paragraph="'Monetize and grow your audience using our powerful data and insights that track listenership across devices, regions, countries and more.'"
        :title="'Analytics'"
        button-text="Create your podcast"
        class="statisticsInfographicSection"
      >
        <KeenSlider :arrows="false" :auto-switch="true" :drag="true">
          <div class="keen-slider__slide slideSlot">
            <img
              alt="Chart showing geographical distribution of podcast episode downloads within Africa"
              class="sliderImage"
              height="467"
              src="static/images/home/analytics-slides/analytics-slide-01.webp"
              width="570"
            />
            <div class="slideShadow" />
          </div>
          <div class="keen-slider__slide slideSlot">
            <img
              alt="Chart showing source distribution of podcast episode downloads"
              class="sliderImage"
              height="467"
              src="static/images/home/analytics-slides/analytics-slide-02.webp"
              width="570"
            />
            <div class="slideShadow" />
          </div>
          <div class="keen-slider__slide slideSlot">
            <img
              alt="Chart showing podcast episode downloads by time of day"
              class="sliderImage"
              height="467"
              src="static/images/home/analytics-slides/analytics-slide-03.webp"
              width="570"
            />
            <div class="slideShadow" />
          </div>
          <div class="keen-slider__slide slideSlot">
            <img
              alt="Chart showing geographical distribution of podcast episode downloads globally"
              class="sliderImage"
              height="467"
              src="static/images/home/analytics-slides/analytics-slide-04.webp"
              width="570"
            />
            <div class="slideShadow" />
          </div>
        </KeenSlider>
      </InfographicSection>
    </section>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router/composables'

import InfographicSection from 'components/reused-components/infographicSection/InfographicSection'
import KeenSlider from 'components/reused-components/keenSlider/KeenSlider'

const router = useRouter()

const onRedirect = (routeName) => {
  router.push({ name: routeName })
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/base/bootstrap_variables';
@import 'assets/scss/base/functions';

.sectionFrame {
  width: 100vw;
  min-height: calc(100vh - 72px);
  background-color: $color-white;
  background-image: url('/static/images/home/frame-pattern-darker.svg');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: top;
  background-size: cover;

  @media (min-width: $screen-sm-min) {
    min-height: calc(100vh - 96px);
  }

  .statisticsSection {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 1252px;
    height: 100%;
    padding: 0 16px;
    margin: 40px auto;
    color: $color-black;
    background-color: transparent;

    @media (min-width: $screen-sm-min) {
      padding: 0 32px;
    }

    .statisticsInfographicSection {
      margin-top: 0;

      .slideSlot {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 712.5px;
        height: auto;

        .sliderImage {
          z-index: 2;
          width: 100%;
          max-width: 572px;
          height: auto;
          border: 1px solid $light-grey;
          border-radius: 4px;

          @media (min-width: $screen-sm-min) {
            width: 80%;
          }
        }

        .slideShadow {
          z-index: 1;
          width: 70%;
          height: 15px;
          margin-bottom: 20px;
          background: rgb(0 0 0 / 30%);
          filter: blur(10px);
          border-radius: 50%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// StatisticsSection.vue